import { useMutation, useQueryClient } from '@tanstack/react-query'
import { onboardingService } from './onboarding.service'

export function useCompleteOnboarding() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => onboardingService.complete(),
    onSuccess: () => {
      queryClient.setQueryData(['onboarding', 'status'], { completed: true, completedAt: new Date().toISOString() })
    },
  })
}
